import React from 'react';
import ReactDOM from 'react-dom';
import thunkMiddleware from 'redux-thunk';
import { BrowserRouter } from 'react-router-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';

import Raven from 'raven-js';

import reducers from './reducers'
import deserialize from './utils/deserialize';

import createRoute from './routes';
import App from './App';
import './index.css';

if (process.env.REACT_APP_SENTRY_DSN) {
  Raven.config(process.env.REACT_APP_SENTRY_DSN).install();
}

const serialized = document.getElementById('initial-data').getAttribute('data-json');
const preloadedState = deserialize(eval('(' + serialized + ')'));

const initialState = {
  entities: preloadedState.get('entities'),
  profile: preloadedState.get('profile'),
  post: preloadedState.get('post'),
  device: preloadedState.get('device'),
  appdata: preloadedState.get('appdata'),
  portal: preloadedState.get('portal'),
  membership: preloadedState.get('membership'),
  wheel: 1,
  phase: preloadedState.get('phase', 'sandbox'),
  error: preloadedState.get('error'),
  referer: preloadedState.get('referer'),
  cookie: document.cookie
};

const devTools = process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const middleware = applyMiddleware(thunkMiddleware);
const enhancer = devTools ? compose(middleware, devTools) : middleware;
const store = createStore(
  reducers,
  initialState,
  enhancer
);

try {
  ReactDOM.render(
    <Provider store={store}>
      <App router={(
        <BrowserRouter>
          {createRoute()}
        </BrowserRouter>
      )} />
    </Provider>,
    document.getElementById('root')
  );
} catch (e) {
  console.log(e);
  if (process.env.REACT_APP_SENTRY_DSN) {
    Raven.captureException(e);
  }
}



// WEBPACK FOOTER //
// ./src/index.js